<template>
  <div v-if="loading && !hasSections" class="tw-flex tw-justify-center tw-py-4">
    <WdsSpinner :size="24" indeterminate data-test="hire-panel-custom-fields-loading" />
  </div>

  <WdsAlert v-else-if="error" error data-test="hire-panel-custom-fields-error">
    {{ $t('The hire custom fields could not be loaded.') }}
  </WdsAlert>

  <HireCustomFieldsGroup
    v-else-if="hasSections"
    data-test="hire-panel-custom-fields"
    :title="$t('Hire custom fields')"
    :subtitle="$t('Specific to this hire')"
    :sections="sections"
    hide-search
  />
</template>

<script lang="ts" setup>
import { WdsAlert, WdsSpinner } from '@worksome/wds-components'
import HireCustomFieldsGroup from '@/components/Hire/HirePageParts/HireCustomFieldsGroup.vue'
import { useHireCustomFields } from '@/components/Hire/composables/useHireCustomFields'
import { HireCustomFieldsAnsweredBy } from '@/components/Hire/composables/useHireCustomFieldSections'
import { $t } from '@/composables/translation'

// Every section shows unless answeredBy picks one side.
const props = defineProps<{ hireId: string; answeredBy?: HireCustomFieldsAnsweredBy }>()

const { sections, hasSections, loading, error } = useHireCustomFields(
  () => props.hireId,
  () => props.answeredBy,
)
</script>
